export default {
  integration: null,
  integrationZoomWebinars: null,
  integrationSendGrid: null,
  integrationWhatsApp: null,
  unsubscribeIntegrationWhatsApp: null,
  integrationFbCatalog: null,
};
